export enum EcommerceApiRoutes {
  // Loads the ecommerce session (consumer + vehicle data) by its session id.
  // The callback -> session id resolution is handled by /contacts/call-details.
  Session = '/ecommerce/sessions',
}
